import { render, staticRenderFns } from "./selectIconTypePop.vue?vue&type=template&id=272083cb&scoped=true"
import script from "./selectIconTypePop.vue?vue&type=script&lang=ts"
export * from "./selectIconTypePop.vue?vue&type=script&lang=ts"
import style0 from "./selectIconTypePop.vue?vue&type=style&index=0&id=272083cb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272083cb",
  null
  
)

export default component.exports